import { TASK_STATUS } from "config/constants/constants";

const RECENT_TASK_THRESHOLD = 15000; // 15 seconds

/**
 * Check if task is in progress
 */
export const isTaskInProgress = (status) => {
    return [
        TASK_STATUS.IN_PROGRESS,
        TASK_STATUS.QUEUED,
        TASK_STATUS.RUNNING,
        TASK_STATUS.PENDING
    ].includes(status);
};

/**
 * Calculate notification priority for sorting
 * Lower number = higher priority
 */
export const calculatePriority = (notification) => {
    const now = Date.now();

    if (notification.type !== "background_task") {
        return 4; // Regular notifications get lowest priority
    }

    const isRecentlyCompleted =
        ["COMPLETED", "FAILED"].includes(notification.status) &&
        now - notification.lastUpdated < RECENT_TASK_THRESHOLD;

    const isInProgress = isTaskInProgress(notification.status);

    if (isRecentlyCompleted) return 1; // Highest priority
    if (isInProgress) return 2; // Second priority
    return 3; // Other background tasks
};